export const Avatar = ({ f, size = "w-7 h-7" }) => (
  <span className={`${size} rounded-full overflow-hidden bg-[#1C2536] grid place-items-center text-xs font-semibold shrink-0`}>
    {f.picture ? <img src={f.picture} alt="" className="w-full h-full object-cover" referrerPolicy="no-referrer" /> : f.name[0]}
  </span>
);
